@let solution = solution$ | async;


<app-top-bar [title]="display_name" [isBack]="true"></app-top-bar>
<div class="support-solution-container">
  @if (solution) {
    <div class="solution-block block-background main-text-color">
      @for (item of solution; track $index) {
        <section class="solution-item">
<!--          <div class="solution-title">{{item.title}}</div>-->
          <div class="solution-content" [innerHTML]="item.content | safe: 'html'"></div>
        </section>
      }
    </div>
  } @else {
    <app-progress-spinner [spinnerText]="'Завантаження рішень'"></app-progress-spinner>
  }
  <div class="actions-block">
    <div class="title-action block-background main-text-color">
      Ця інформація вирішує вашу проблему?
    </div>
    <div class="body-action block-background">
      @if (showActions) {
        <button class="main-button positive-button accent-color-background button-border-color-accent"
                (click)="acceptSolution()"
                mat-flat-button>Так, вирішує</button>
        <button class="main-button negative-button button-border-color button-text-color"
                (click)="openCreateTicket()"
                mat-stroked-button>Зв’язатися з підтримкою</button>
      } @else {
        <div class="no-action">
          <div class="like default-background">
            <mat-icon class="alert-color">favorite</mat-icon>
          </div>
          <span class="main-text-color">Дякуємо за відгук!</span>
        </div>
      }
    </div>
  </div>
</div>
